/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.clientSubstatusOverlayEdit{height:100%}.overlay.clientSubstatusOverlayEdit .content{box-shadow:none}.overlay.clientSubstatusOverlayEdit .ol-main{background:#f5f5f5}"];
export { styles as styles };
